<div class="!relative" data-phone-country>
    <label *ngIf="label"
           class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600"
           [class.required]="required"
           [attr.for]="inputId">
        {{ label }}
    </label>
    <div class="!flex !h-11 !min-h-11 !overflow-hidden !rounded-xl !border !border-solid !bg-white focus-within:!border-primary focus-within:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
         [ngClass]="!isPhoneValid ? '!border-red-500' : '!border-slate-200'">
        <button type="button"
                class="!m-0 !inline-flex !h-full !shrink-0 !appearance-none !items-center !gap-1.5 !border-0 !border-r !border-solid !border-slate-200 !bg-slate-50 !px-3 !text-sm !font-semibold !text-slate-800 !shadow-none hover:!bg-slate-100 focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-inset focus-visible:!ring-primary"
                aria-haspopup="listbox"
                [attr.aria-expanded]="isPhoneCountryOpen"
                aria-label="Prefisso internazionale"
                (click)="togglePhoneCountryDropdown()">
            <span aria-hidden="true">{{ selectedPhoneCountry.flag }}</span>
            <span>{{ selectedPhoneCountry.dialCode }}</span>
            <i class="bi !text-xs !text-slate-400"
               [ngClass]="isPhoneCountryOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
               aria-hidden="true"></i>
        </button>
        <input type="tel"
               inputmode="numeric"
               autocomplete="tel-national"
               class="!m-0 !box-border !h-full !min-h-0 !min-w-0 !flex-1 !appearance-none !border-0 !bg-white !px-3.5 !py-0 !text-base !tabular-nums !text-slate-800 !shadow-none !outline-none focus:!ring-0"
               [id]="inputId"
               [name]="name"
               [required]="required"
               [placeholder]="placeholder"
               [ngModel]="formattedPhoneNationalNumber"
               (input)="onPhoneInput($event)">
    </div>
    <ul *ngIf="isPhoneCountryOpen"
        role="listbox"
        class="!absolute !left-0 !z-30 !m-0 !mt-1.5 !w-full !max-h-64 !list-none !overflow-y-auto !rounded-xl !border !border-solid !border-slate-200 !bg-white !p-0 !shadow-[0_12px_32px_rgba(15,23,42,0.12)]">
        <li *ngFor="let country of phoneCountries"
            class="!m-0 !border-0 !border-b !border-solid !border-slate-100 last:!border-b-0"
            role="none">
            <button type="button"
                    role="option"
                    class="!m-0 !flex !w-full !appearance-none !items-center !justify-between !gap-3 !border-0 !bg-white !px-3.5 !py-2.5 !text-left !shadow-none hover:!bg-slate-50"
                    [ngClass]="country.dialCode === selectedPhoneCountry.dialCode ? '!bg-primary-soft !text-slate-900' : '!bg-white !text-slate-700'"
                    [attr.aria-selected]="country.dialCode === selectedPhoneCountry.dialCode"
                    (click)="selectPhoneCountry(country)">
                <span class="!inline-flex !min-w-0 !items-center !gap-2">
                    <span aria-hidden="true">{{ country.flag }}</span>
                    <span class="!truncate !text-sm !font-medium">{{ country.name }}</span>
                </span>
                <span class="!shrink-0 !text-sm !font-semibold !tabular-nums">{{ country.dialCode }}</span>
            </button>
        </li>
    </ul>
    <p *ngIf="showHint" class="!mb-0 !mt-1.5 !text-xs !leading-snug !text-slate-400">
        {{ selectedPhoneCountry.name }} · salveremo {{ selectedPhoneCountry.dialCode }} {{ formattedPhoneNationalNumber || '…' }}.
    </p>
</div>
